import dayjs from 'dayjs';
import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { COMMON_DATETIME_FORMAT } from 'constants/date';

import { selectLoanApplication } from './loanApplication.selectors';

export const selectTaskSlaGroup = createSelector(
  selectLoanApplication,
  ({ taskSlaGroup }) => taskSlaGroup,
);

export const selectTaskSlaGroupLevelsData = memoizeOne(taskSlaGroupId =>
  createSelector(selectTaskSlaGroup, slaGroups => {
    const slaGroup = slaGroups[taskSlaGroupId];

    if (slaGroup?.levels) {
      const { levels } = slaGroup;
      const sortedLevels = _.sortBy(levels, 'orderNumber');
      const activeIndex = sortedLevels.findIndex(level => slaGroup.activeLevelId === level.id);

      return sortedLevels.map((level, index) => {
        const assignedUsers = index <= activeIndex ? level.assignedUsers : null;

        return {
          ...level,
          orderNumber: level.orderNumber + 1,
          isActive: index < activeIndex || (index === activeIndex && !!level.startDate),
          assignedUsers,
          type: level.assignToSingleUser ? 'Single' : 'Multiple',
          startDate: level.startDate
            ? dayjs(level.startDate).format(COMMON_DATETIME_FORMAT)
            : 'N/A',
          potentialAssignees: level.potentialAssignees,
        };
      });
    }

    return [];
  }),
);
